module.exports = __webpack_public_path__ + "img/phone.7e146201.svg";